import { Component } from '@angular/core';
import { UserdataService } from '../service/userdata.service';
import { AppdataService } from '../service/appdata.service';

@Component({
  selector: 'app-home',
  standalone: false,

  templateUrl: './home.component.html',
  styleUrl: './home.component.scss'
})
export class HomeComponent {
  name = ""
  showGreets: boolean = true;
  showMenue: boolean = true;
  constructor(
    private user: UserdataService,
    private appData: AppdataService
  ) {
    appData.showMenue.subscribe((data) => {
      this.showMenue = data;
    })
    user.data.subscribe((data) => {
      this.name = data.prename
    });
    appData.showGreeting.subscribe((data) => {
      this.showGreets = data;
    })
  }

  closeGreet() {
    localStorage.setItem('ids_greet', 'false')
    this.appData.showGreeting.next(false)
  }

}
